import { coreClient } from "@/api/CoreService";

export interface GepAiVoiceCallStatus {
  enabled: boolean;
  gepEnabled: boolean;
  gepAiOnlyEnabled: boolean;
  aiAutoAnswerEnabled: boolean;
  humanAgentRequestEnabled: boolean;
  nextTransitionAt?: string;
}

/**
 * The browser only uses this as a display gate. Vouch Core independently
 * enforces the `gep` surface when it creates a room.
 */
export const getGepAiVoiceCallStatus = (merchantId: string) =>
  coreClient.instance
    .get<GepAiVoiceCallStatus>("/api/v2/video-caller-widget/status", {
      params: { merchantId, surface: "gep" },
      skipUnauthorizedRedirect: true,
    })
    .then((response) => response.data);
